package com.milta.core.localization.translations.nl

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "AI",
    menuAiLegend = "AI: automatisch lezen door artificiële intelligentie, wat uw AI-tegoed gebruikt. Voor Excel alleen als de kolommen niet herkend worden.",
    menuExhaustedTitle = "AI-tegoed opgebruikt — reset op {date}.",
    menuExhaustedMessage = "Scannen en PDF-import zijn uitgeschakeld. Een spreadsheet met de verwachte kolommen en handmatige invoer blijven mogelijk.",
    modeDisabledReason = "AI-tegoed opgebruikt",
    exhaustedBannerWebTitle = "AI-tegoed opgebruikt — reset op {date}.",
    exhaustedBannerWebMessage = "PDF's kunnen niet meer worden geanalyseerd. Importeer een Excel- of CSV-bestand met de verwachte kolommen, of voeg de leveringen handmatig toe via de mobiele app.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) of CSV · max. 500 stops · 10 MB",
    pdfUnavailableUntil = "PDF niet beschikbaar tot {date}",
    pdfRefusedTitle = "AI-tegoed opgebruikt — deze PDF kan niet worden geanalyseerd",
    pdfRefusedMessage = "“{file}” moet door AI worden gelezen. Uw tegoed is weer beschikbaar op {date}. Importeer tot dan een Excel- of CSV-bestand met de verwachte kolommen, of voeg de leveringen handmatig toe via de mobiele app.",
    spreadsheetExhaustedTitle = "Kolommen niet herkend — AI-tegoed opgebruikt",
    spreadsheetExhaustedWebMessage = "De kolommen van “{file}” komen niet overeen met de verwachte kolommen, en uw AI-tegoed volstaat niet meer om ze automatisch te koppelen (weer beschikbaar op {date}). Hernoem de kolommen zoals hieronder, of voeg de leveringen handmatig toe via de mobiele app.",
    expectedColumnsNoCreditHint = "Een bestand dat deze kolommen volgt, wordt zonder AI geïmporteerd en verbruikt geen tegoed, zelfs niet bij 0%.",
    importExhaustedTitle = "AI-tegoed opgebruikt",
    importExhaustedPhotoMessage = "Uw AI-tegoed bereikte 0% terwijl deze import wachtte. De foto is niet geanalyseerd en er is niets aangerekend. Reset op {date}.",
    importExhaustedFileMessage = "Uw AI-tegoed bereikte 0% terwijl deze import wachtte. Het bestand is niet geanalyseerd en er is niets aangerekend. Reset op {date}.",
    importSpreadsheetExhaustedMessage = "De kolommen van dit bestand komen niet overeen met de verwachte kolommen, en uw AI-tegoed volstaat niet meer om ze automatisch te koppelen. Reset op {date}.",
    stepPhotoSent = "Foto verzonden",
    stepFileSent = "Bestand verzonden: {file}",
    stepAnalysisNotStarted = "Analyse niet gestart: AI-tegoed opgebruikt",
    stepFileRead = "Bestand gelezen: {file}",
    stepExpectedColumns = "Verwachte kolommen: Naam van de ontvanger, Volledig adres",
    stepDeliveriesKept = "Reeds ingevoerde leveringen blijven behouden",
    retryAvailableOn = "Opnieuw proberen — beschikbaar op {date}",
    manualEntryAction = "Handmatige invoer",
    myUsageTitle = "Mijn gebruik",
    myUsageAttachedDriverNote = "Hier verschijnen alleen uw eigen acties. Wat uw ondernemingen voor u starten, wordt bij hen geteld.",
    tabOptimizations = "Optimalisaties",
    tabAiCredit = "AI-tegoed",
    remainingForPeriod = "Resterend AI-tegoed voor deze periode",
    percentValue = "{percent}%",
    remainingSuffix = "AI-tegoed resterend",
    lowPill = "Tegoed laag",
    exhaustedPill = "Opgebruikt · scannen en PDF-import uitgeschakeld",
    driverNote = "Uw tegoed wordt hersteld bij de verlenging van het abonnement (dat van uw Onderneming als u er deel van uitmaakt). Ongebruikt tegoed wordt niet overgedragen.",
    enterpriseNote = "Wordt hersteld bij de verlenging van uw abonnement, zonder overdracht. Dit tegoed geldt alleen voor uw eigen AI-acties; elke chauffeur heeft zijn eigen tegoed.",
    exhaustedNote = "Handmatige invoer en spreadsheets met de verwachte kolommen blijven beschikbaar. Het tegoed wordt hersteld bij de verlenging van uw abonnement.",
    webScopeHint = "Dit tegoed geldt alleen voor de AI-acties van dit account: scans, PDF- of foto-imports, niet-herkende spreadsheetkolommen. Elke chauffeur heeft zijn eigen tegoed.",
    profileValue = "{optimizations} · AI {percent}%",
    profileValueAiOnly = "AI {percent}%",
    columnShare = "Aandeel van het tegoed",
    actionScanDeliveryList = "Lijstscan",
    actionScanPackageLabel = "Etiketscan",
    actionImportPdf = "PDF-import",
    actionImportUnstructured = "Import op de achtergrond",
    actionSpreadsheetMapping = "Spreadsheetkolommen (AI)",
    outcomeSuccess = "Geslaagd",
    outcomeFailed = "Mislukt",
    outcomeUnreadable = "Onleesbaar",
    countedSuffix = "(aangerekend)",
    rowDateTime = "{date} om {time}",
    limitsEyebrow = "AI-tegoed per periode",
    limitsDescription = "Bedrag in euro dat elk account per abonnementsperiode mag verbruiken aan AI-aanroepen (scans, PDF- of foto-imports, niet-herkende spreadsheetkolommen). Het tegoed keert terug naar de limiet bij de verlenging van het abonnement, zonder overdracht.",
    weightedEquivalent = "≈ {tokens} gewogen tokens",
    limitsFootnote = "Een chauffeur van een Onderneming krijgt de limiet “Chauffeur”, proef zolang zijn Onderneming in proef is. Het equivalent in tokens is indicatief en wordt herberekend met de koers hieronder.",
    conversionEyebrow = "Omrekening en waarschuwing",
    rateLabel = "Wisselkoers",
    rateHint = "Handmatig bijgewerkt · geldt voor de volgende aanroepen",
    thresholdLabel = "Waarschuwing laag tegoed",
    thresholdUnit = "% resterend",
    thresholdHint = "Percentage in oranje en banner één keer per periode",
    calculationTitle = "Hoe de kosten van een aanroep worden berekend.",
    calculationBody = "Claude Haiku 4.5: 1 $ per miljoen invoertokens, 5 $ per miljoen uitvoertokens. Gewogen token = invoer × 1 + uitvoer × 5, dus 1 $ = 1.000.000 gewogen tokens. Kosten in euro = kosten in dollar ÷ koers. Voorbeeld: een gemiddelde lijstscan (5.014 invoer + 1.792 uitvoer) = 13.974 gewogen tokens = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Limieten opgeslagen.",
    settingsSavedDetail = "Onderneming: {enterpriseTrial} proef · {enterprisePaid} betaald. Chauffeur: {driverTrial} proef · {driverPaid} betaald. Koers {rate}. Waarschuwing {threshold}%.",
    limitTooHigh = "Maximaal 1.000 €.",
    rateTooHigh = "Maximaal 10.",
    thresholdOutOfRange = "Tussen 1 en 99.",
    adminCreditTitle = "AI-tegoed",
    adminRemainingLine = "≈ {tokens} gewogen tokens resterend · verbruikt {consumed}",
    adminOverrunLine = "Verbruikt {consumed} · overschrijding van {over}",
    adminLowPill = "Tegoed laag · onder {threshold}%",
    adminLowPillNoThreshold = "Tegoed laag",
    adminExhaustedPill = "Tegoed opgebruikt · AI-acties uitgeschakeld",
    adminAppliedAfterReplacement = "{consumed} verbruikt + {remaining} resterend (vervanging)",
    adminGlobalLimitLabel = "Globale limiet",
    adminGlobalLimitResumes = "{source} — geldt weer vanaf de reset",
    adminResetNoCarryOver = "Start opnieuw op {limit}: de overschrijding wordt niet overgedragen",
    replaceLabel = "Resterend tegoed vervangen",
    replaceHelp = "Van 0 tot 100 €, alleen voor de huidige periode. Bij de reset start het account opnieuw vanaf de globale limiet.",
    replaceHelpEnterpriseDriver = "Wijzigt alleen het tegoed van {name}. Dat van de Onderneming en van de andere chauffeurs verandert niet.",
    replaceInvalid = "Voer een bedrag van 0 tot 100 € in.",
    replacedTitle = "Resterend tegoed vervangen: {from} → {to}.",
    replacedDetail = "Voor de huidige periode. Op {date} terug naar de globale limiet ({limit}).",
    adminHistoryTitle = "Geschiedenis van het AI-tegoed",
    adminPeriodSummary = "Huidige periode sinds {start}: {calls} aanroepen · {failed} mislukt of onleesbaar (aangerekend) · {tokens} gewogen tokens · {consumed}",
    columnInput = "Invoer",
    columnOutput = "Uitvoer",
    columnWeighted = "Gewogen",
    columnCost = "Kosten",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "Uw AI-tegoed is opgebruikt. Het bestand is niet geanalyseerd en er is niets aangerekend. Reset op {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
